import React from 'react';
import CornerBadge from './Badge';

interface LocationBadgeProps {
  onLocationFound: (lat: number, lng: number) => void;
}

const LocationBadge: React.FC<LocationBadgeProps> = ({ onLocationFound }) => {
  const handleLocationClick = () => {
    if (!navigator.geolocation) {
      console.error('Geolocation is not supported by your browser');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        onLocationFound(latitude, longitude);
      },
      (error) => {
        console.error('Error getting location:', error);
      }
    );
  };

  return (
    <CornerBadge
      text="My Location"
      onClick={handleLocationClick}
      vertical="top"
      horizontal="left"
      colorScheme="yellow"
      icon="location"
    />
  );
};

export default LocationBadge;